var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 32.692"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.522 15.179 2.821.483A1.651 1.651 0 1 0 .487 2.815l13.535 13.53L.487 29.875a1.651 1.651 0 0 0 2.337 2.334l14.7-14.7a1.665 1.665 0 0 0-.002-2.33"
  })));
};
export default SvgArrowRight;